// Client cho booking-ai-worker. Forward JWT user qua Authorization header.
//
// BASE configured qua VITE_AI_BASE (vd http://localhost:8788). Empty → same-origin.

import { getToken } from "./auth";
import type { AIConfig, ApiErrorBody, ChatMessage, ChatResponseBody, ToolMeta } from "./types";
import { ApiError } from "./api";

const BASE = (import.meta.env.VITE_AI_BASE as string | undefined) ?? "";

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers || {});
  const t = getToken();
  if (t) headers.set("Authorization", `Bearer ${t}`);
  if (init.body && !headers.has("Content-Type")) headers.set("Content-Type", "application/json");

  const resp = await fetch(`${BASE}${path}`, { ...init, headers });
  if (!resp.ok) {
    let body: ApiErrorBody | string = resp.statusText;
    try {
      body = (await resp.json()) as ApiErrorBody;
    } catch {
      /* ignore */
    }
    throw new ApiError(resp.status, body);
  }
  if (resp.status === 204) return undefined as unknown as T;
  return (await resp.json()) as T;
}

export const ai = {
  health: () => fetch(`${BASE}/health`).then((r) => r.ok),
  chat: (body: { messages: ChatMessage[]; approved_tool_calls?: string[] }) =>
    request<ChatResponseBody>("/chat", { method: "POST", body: JSON.stringify(body) }),
  tools: () => request<ToolMeta[]>("/tools"),
  getConfig: () => request<AIConfig>("/config"),
  putConfig: (cfg: AIConfig) =>
    request<AIConfig>("/config", { method: "PUT", body: JSON.stringify(cfg) }),
  models: () => request<string[]>("/models"),
};
